import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-32 pb-24 md:pt-40 md:pb-32 overflow-hidden bg-teh-deep"
    >
      {/* Background image */}
      <div className="absolute inset-0 bg-teh-deep">
        <img
          src="https://images.pexels.com/photos/6129502/pexels-photo-6129502.jpeg?auto=compress&cs=tinysrgb&w=1920"
          alt="Diverse healthcare professionals"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(105deg, rgba(0,31,61,0.85) 0%, rgba(0,31,61,0.55) 40%, rgba(0,51,102,0.15) 75%, rgba(0,51,102,0) 100%)" }} />
      </div>

      <div className="relative z-10 teh-container">
        <div className="max-w-4xl">
          <div className="teh-fade-up flex items-center gap-3">
            <span className="teh-pill !text-white !border-white/30 !bg-white/10">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
              Now Serving Georgia
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="teh-fade-up teh-delay-1 font-serif text-white mt-7 text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight"
          >
            Healthcare that begins
            <br />
            with a{" "}
            <span className="italic text-emerald-300">first touch.</span>
          </h1>

          <p
            data-testid="hero-subhead"
            className="teh-fade-up teh-delay-2 mt-8 text-lg md:text-xl text-white max-w-2xl leading-relaxed"
          >
            1st Touch Enterprise Holdings is a Georgia-based, minority- and
            woman-owned healthcare enterprise — bringing home health, transportation,
            therapy, equipment, and workforce development under one trusted family of care.
          </p>

          <div className="teh-fade-up teh-delay-3 mt-10 flex flex-wrap items-center gap-4">
            <Link
              to="/services"
              data-testid="hero-cta-primary"
              className="inline-flex items-center gap-2 px-7 py-4 bg-white text-teh-navy text-sm font-medium rounded-full hover:bg-emerald-300 hover:text-teh-deep transition-all duration-300 hover:gap-3"
            >
              Explore our services
              <ArrowRight className="w-4 h-4" strokeWidth={1.8} />
            </Link>
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                data-testid="hero-cta-call"
                className="inline-flex items-center gap-2 px-7 py-4 border border-white/30 text-white text-sm font-medium rounded-full hover:bg-white/10 transition-all duration-300"
              >
                <Phone className="w-4 h-4" strokeWidth={1.8} />
                {COMPANY.phone}
              </a>
          </div>

          <div className="teh-fade-up teh-delay-4 mt-16 flex flex-wrap items-center gap-x-8 gap-y-3 text-white/70 text-sm">
            <span className="text-xs uppercase tracking-[0.22em] text-emerald-300">
              {COMPANY.tagline}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
